import { ref, unref, onMounted, onUnmounted } from 'vue';
function unrefElement(elRef) {
    var _a, _b;
    return (_b = (_a = unref(elRef)) === null || _a === void 0 ? void 0 : _a.$el) !== null && _b !== void 0 ? _b : unref(elRef);
}
export default function useLiveElementRect(elRef) {
    var rect = ref();
    function checkPosition() {
        var box = unrefElement(elRef);
        if (box) {
            var boxRect = box.getBoundingClientRect();
            rect.value = boxRect;
        }
    }
    onMounted(function () {
        window.addEventListener('resize', checkPosition);
    });
    onUnmounted(function () {
        window.removeEventListener('resize', checkPosition);
    });
    return [rect, checkPosition];
}
